import { LISTING_PORTAL_SYNC_STATUS } from '../RentalPortalListing.constants'

export const LISTING_PUBLICATION_SYNC_STATUSES = {
  [LISTING_PORTAL_SYNC_STATUS.deactivated]: {
    text: 'RentalPortal.ListingProfilePortalDeactivatedKey',
    textColor: 'var(--color-warning)',
  },
  [LISTING_PORTAL_SYNC_STATUS.deactivating]: {
    text: 'RentalPortal.ListingProfilePortalDeactivatingKey',
    textColor: 'var(--color-info)',
  },
  [LISTING_PORTAL_SYNC_STATUS.error]: {
    text: 'RentalPortal.ListingProfilePortalErrorKey',
    textColor: 'var(--color-error)',
  },
  [LISTING_PORTAL_SYNC_STATUS.notPublished]: {
    text: 'RentalPortal.ListingProfilePortalNotPublishedKey',
    textColor: 'var(--secondary-text-color)',
  },
  [LISTING_PORTAL_SYNC_STATUS.published]: {
    text: 'RentalPortal.ListingProfilePortalLiveKey',
    textColor: 'var(--color-success)',
  },
  [LISTING_PORTAL_SYNC_STATUS.publishing]: {
    text: 'RentalPortal.ListingProfilePortalPublishingKey',
    textColor: 'var(--color-info)',
  },
  [LISTING_PORTAL_SYNC_STATUS.queued]: {
    text: 'RentalPortal.ListingProfilePortalQueuedKey',
    textColor: 'var(--color-info)',
  },
  [LISTING_PORTAL_SYNC_STATUS.updatePending]: {
    text: 'RentalPortal.ListingProfilePortalUpdatePendingKey',
    textColor: 'var(--color-warning)',
  },
  [LISTING_PORTAL_SYNC_STATUS.updating]: {
    text: 'RentalPortal.ListingProfilePortalUpdatingKey',
    textColor: 'var(--color-info)',
  },
}

export const LISTING_PUBLICATION_UNKNOWN_SYNC_STATUS = {
  text: 'RentalPortal.ListingProfilePortalStatusUnknownKey',
  textColor: 'var(--secondary-text-color)',
}

export const LISTING_PUBLICATION_ERROR_TEXT_KEY = {
  portal_rejected: 'RentalPortal.ListingPublicationErrorRejectedKey',
  portal_unreachable: 'RentalPortal.ListingPublicationErrorUnreachableKey',
}
